<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>用户管理</el-breadcrumb-item>
      <el-breadcrumb-item>用户列表</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card>
      <el-row :gutter="0">
        <el-col :span="9">
          <el-input
            placeholder="请输入查询内容"
            v-model="queryInfo.query"
            class="input-with-select"
            clearable
            style="width:300px;"
            @clear="getuserList"
            @change="getuserList"
          >
            <el-button slot="append" icon="el-icon-search" @click="getuserList"></el-button>
          </el-input>
        </el-col>
        <el-col :span="4">
          <el-button type="primary" @click="openAddDialog">添加用户</el-button>
        </el-col>
      </el-row>
      <el-row :gutter="0" class="el_row_two">
        <el-col :span="24">
          <el-table :data="userList" style="width: 100%" border stripe>
            <!-- <el-table-column type="index" label="序号" width="80"></el-table-column> -->
            <el-table-column prop="uid" label="序号" width="80"></el-table-column>
            <el-table-column prop="user_name" label="用户名称" w></el-table-column>
            <el-table-column prop="user_xingming" label="姓名" w></el-table-column>
            <el-table-column prop="user_mob" label="手机"></el-table-column>
            <el-table-column prop="user_pass" label="密码"></el-table-column>

            <el-table-column label="操作">
              <template v-slot="scope">
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="修改"
                  placement="top"
                  :enterable="false"
                >
                  <el-button
                    type="primary"
                    icon="el-icon-edit"
                    @click="showEditDialog(scope.row.uid)"
                    circle
                    size="mini"
                  ></el-button>
                </el-tooltip>
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="删除"
                  placement="top"
                  :enterable="false"
                >
                  <el-button
                    v-show="(scope.row.user_name !== 'admin')"
                    type="danger"
                    icon="el-icon-delete"
                    circle
                    size="mini"
                    @click="deleteForm(scope.row.uid)"
                  ></el-button>
                </el-tooltip>
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="设置"
                  placement="top"
                  :enterable="false"
                >
                  <el-button
                    v-show="(scope.row.user_name !== 'admin')"
                    type="success"
                    icon="el-icon-orange"
                    circle
                    size="mini"
                  ></el-button>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="queryInfo.pageNum"
        :page-sizes="[10,50]"
        :page-size="queryInfo.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
        <!--分页组件，其中handleSizeChange 条数下拉触发事件，  handleCurrentChange  选择分页出发事件 currentPage2 当前页绑定 page-sizes 下拉显示列表 page-size 每页多少条绑定 layout 显示分页的元素 total 合计条数绑定  -->
      </el-pagination>
      <!-- 添加用户部分 -->
      <el-dialog title="添加用户" :visible.sync="addDialogVisible" width="50%" @close="addDoalogClosed">
        <el-form ref="addFormRef" :model="addForm" :rules="addFormRules" label-width="100px">
          <el-form-item label="选择角色" prop="juese_uid">
            <el-select
              v-model="addForm.juese_uid"
              placeholder="选择角色"
              @change="getJueseList"
            >
              <el-option
                v-for="item in jueseList"
                :key="item.uid"
                :label="item.juese_name"
                :value="item.uid"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="用户名称" prop="user_name">
            <el-input v-model="addForm.user_name"></el-input>
          </el-form-item>
          <el-form-item label="用户密码" prop="user_pass">
            <el-input v-model="addForm.user_pass"></el-input>
          </el-form-item>
          <el-form-item label="用户姓名" prop="user_xingming">
            <el-input v-model="addForm.user_xingming" max="11" min="10"></el-input>
          </el-form-item>
          <el-form-item label="联系手机号" prop="user_mob">
            <el-input v-model="addForm.user_mob" max="11" min="10"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="addDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="adduser">确 定</el-button>
        </span>
      </el-dialog>
      <!-- 修改用户信息 -->
      <el-dialog
        title="修改用户信息"
        :visible.sync="editDialogVisible"
        width="50%"
        @close="editDoalogClosed"
      >
        <el-form ref="editFormRef" :model="addForm" :rules="editFormRules" label-width="100px">
          <el-form-item label="选择角色" prop="juese_uid">
            <el-select
              v-model="addForm.muyuan_chengshi_uid"
              placeholder="选择角色"
              @change="getJueseList"
            >
              <el-option
                v-for="item in jueseList"
                :key="item.uid"
                :label="item.juese_name"
                :value="item.uid"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="用户名称" prop="user_name">
            <el-input v-model="editForm.user_name"></el-input>
          </el-form-item>
          <el-form-item label="用户密码" prop="user_pass">
            <el-input v-model="editForm.user_pass"></el-input>
          </el-form-item>
          <el-form-item label="用户姓名" prop="user_xingming">
            <el-input v-model="editForm.user_xingming" max="11" min="10"></el-input>
          </el-form-item>
          <el-form-item label="联系手机号" prop="user_mob">
            <el-input v-model="editForm.user_mob" max="11" min="10"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="editDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="updateuser">确 定</el-button>
        </span>
      </el-dialog>
    </el-card>
  </div>
</template>
<script>
export default {
  data() {
    return {
      // 删除按钮是否可见
      // 获取用户列表参数
      queryInfo: {
        //   token: window.sessionStorage.getItem('token'), // 递交数据，必须携带token ，进行验证
        C_type: 'get_list',
        C_table_name: 'user_list',
        query: '',
        pageNum: 1,
        pageSize: 10
      },
      userList: [],
      // 用于下拉框的数据读取
      jueseList: [],
      //  recordCount: 0,
      total: 0,
      addDialogVisible: false,
      editDialogVisible: false,
      //  添加表单数据项
      addForm: {
        C_type: 'user_add',
        user_name: '',
        user_pass: '123456',
        user_xingming: '',
        user_mob: '',
        juese_uid: ''
      },
      // 用于修改数据绑定
      editForm: {},
      // 表单规则项
      addFormRules: {
        user_name: [
          { required: true, message: '请输入用户名称', trigger: 'blur' },
          { min: 1, max: 10, message: '必须1到10位字符 ', trigger: 'blur' }
        ],
        user_mob: [
          { required: true, message: '请输入管理员手机号码', trigger: 'blur' },
          { min: 11, max: 11, message: '必须是11位 ', trigger: 'blur' }
        ]
      },
      editFormRules: {}
    };
  },
  created() {
    this.getuserList();
  },
  methods: {
    openAddDialog() {
         this.getJueseList()
         this.addDialogVisible = true
    },
    async getJueseList() {
       const { data: res } = await this.$http.get('get_api', {
        params: {
        C_table_name: 'user_juese_list', // 调用普通api get接口 2
        C_type: 'get_list',
        query: '',
        pageNum: 1,
        pageSize: 10
        }
      });
      // console.log(res.data)
      this.jueseList = JSON.parse(res.data)[0].dataList
    },

    async getuserList() {
      const { data: res } = await this.$http.get('get_api', {
        params: this.queryInfo
      });
       console.log(JSON.parse(res.data))
      this.userList = JSON.parse(res.data)[0].dataList;

      if (!this.userList) return;
      this.userList.forEach(function(item) {
        item.yong_flag = item.yong_flag === 1;
      });

      this.total = JSON.parse(res.data)[0].total;

      // console.log(this.total);
    },
    //  分页第一项下拉触发

    handleSizeChange(newSize) {
      this.queryInfo.pageSize = newSize;
      this.getuserList();
    },
    // 选择页数触发
    handleCurrentChange(newPage) {
      this.queryInfo.pageNum = newPage;
      this.getuserList();
    },
    addDoalogClosed() {
      this.$refs.addFormRef.resetFields();
    },
    adduser() {
      this.$refs.addFormRef.validate(async valid => {
        if (!valid) return 1;
        const { data: res } = await this.$http.post('api', this.addForm);
        console.log(JSON.parse(res.data)[0].status);
        if (JSON.parse(res.data)[0].status === 202) {
          this.$message.error('用户名重复，添加失败');
          return;
        }
        if (JSON.parse(res.data)[0].status !== 200) {
          this.$message.error('添加失败');
          return;
        }
        this.$message.success('添加成功');
        this.getuserList();
        this.addDialogVisible = false;
      });
    },
    showEditDialog(uid) {
      this.getJueseList()
      this.editDialogVisible = true;
      this.userInfo(uid);
    },
    editDoalogClosed() {
      this.$refs.editFormRef.resetFields();
    },
    async userInfo(uid) {
      const { data: res } = await this.$http.get('get_api', {
        params: { C_table_name: 'user_info', uid: uid, C_type: 'get_info' }
      });
      // console.log(JSON.parse(res.data))
      console.log(res.data);
      if (JSON.parse(res.data)[0].status !== 200) {
        return this.$message.error('读取失败');
      }

      this.editForm = JSON.parse(res.data)[0].data[0];
    },
    async updateuser() {
      this.$refs.editFormRef.validate(async valid => {
        if (!valid) return this.$message.error('验证错误！');
        const { data: res } = await this.$http.post('api', {
          C_type: 'user_update',
          user_uid: this.editForm.uid,
          user_name: this.editForm.user_name,
          user_pass: this.editForm.user_pass,
          user_xingming: this.editForm.user_xingming,
          user_mob: this.editForm.user_mob
        });

        if (JSON.parse(res.data)[0].status !== 200) {
          this.$message.error('更新失败');
          return;
        }
        this.$message.success('更新成功');
        this.getuserList();
        this.editDialogVisible = false;
      });
    },
    // 删除一条记录
    async deleteForm(userUid) {
      // 此处通过异步获取操作行为，而不用then ，来避免异步嵌套
      // 异步操作有2个，1个对话框等待，1个是网络请求
      const comfirmResult = await this.$confirm(
        '确定删除该条记录, 是否继续?',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).catch(err => err);
      console.log(comfirmResult);
      if (comfirmResult === 'cancel') return this.$message.info('已经取消删除');
      const { data: res } = await this.$http.post('api', {
        C_type: 'record_delete',
        C_table_name: 'user_del',
        C_data1: userUid
      });
      if (JSON.parse(res.data)[0].status !== 200) {
        this.$message.error('删除失败');
        return;
      }
      this.$message.success('删除成功');
      this.getuserList();
    }
  }
};
</script>
<style lang="less" scoped>
.card_two {
  margin-top: 30px;
  box-shadow: none !important;
}
.el_row_two {
  margin-top: 30px;
}
</style>
